import { RewardCode } from '@services/appsync/types';
import React from 'react';
import { ActivityRecord } from '../types';
import { amountFmt, dateFmt } from '../util';
import { RecordView } from './RecordView';

type RewardCardProps = {
  record: Extract<ActivityRecord, { type: 'Reward' }>;
};

export const RewardCard: React.FC<RewardCardProps> = ({ record }) => {
  const { amount, posted_at, description } = record.dataType;
  const data: [label: string, value: string][] = [];

  const TITLE: Record<RewardCode, string> & { NA: 'n/a' } = {
    AMF_RESCIND: 'Rescintion',
    AMF_REWARD: 'Reward',
    DEBIT: 'Debit',
    GIFT_REWARD: 'Gift Reward',
    INSTANT_EARN: 'Instant Earn',
    INSTANT_EARNING: 'Instant Earning',
    NA: 'n/a',
    PROMO_DIVIDEND_REWARD: 'Promo Dividend Reward',
    REFEREE: 'Referee',
    REFERRAL: 'Referral',
  };

  const title = TITLE[record.dataType.code ?? 'NA'];

  data.push(['Date', dateFmt(posted_at ?? '')]);
  data.push(['Amount', amountFmt(amount ?? 0)]);
  data.push(['Type', description ?? '']);

  return (
    <RecordView
      dateLabel={dateFmt(posted_at ?? '')}
      activityName={title ?? ''}
      activityDesc=""
      status={''}
      amount={amountFmt(amount ?? 0)}
      data={data}
    />
  );
};
